import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { HarborAccesses } from "./accesses.ts";
import { HarborComponents } from "./components.ts";

// Rule filter values compile to regular expressions, so a rule can say, e.g.,
// that `projectAdmin` on `prod-.*` needs approval. `instance` matches the
// instance's item id.
const HarborFilters = {
  instance: { keys: ["name"] },
  project: { keys: ["name"] },
  role: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type HarborFilters = typeof HarborFilters;

// Keyed by component, so a new component doesn't compile until it has one.
const ITEM_KINDS: Record<keyof typeof HarborComponents, string> = {
  connector: "Connector",
  "harbor-instance": "Harbor instance",
};
// `Registration` hands `itemKind` any string, not just a component key.
const itemKinds: Partial<Record<string, string>> = ITEM_KINDS;

export const HarborRegistration = Registration({
  accesses: HarborAccesses,
  category: "resource",
  components: HarborComponents,
  docs: {
    install: "harbor/installation",
    request: "harbor/requesting-access",
  },
  filters: HarborFilters,
  // An item's id is P0's own name for it. "Name" would read as the connector
  // name that `hosting` asks for.
  identifier: "ID",
  itemKind: (component) => itemKinds[component] ?? component,
  label: "Harbor",
  logoUrl: "https://goharbor.io/img/logos/harbor-icon-color.png",
  maturity: "beta",
  requestType: "requestable",
  // A connector alone grants nothing, so Harbor counts as installed once an
  // instance is.
  useMapping: [{ use: "iam_write", component: "harbor-instance" }],
});

registerIntegration("harbor", HarborRegistration);
